/** ISO 3166-1 alpha-2 codes for player profile + directory (sorted by label). */
export const PLAYER_COUNTRIES = [
  { code: 'AU', label: 'Australia' },
  { code: 'AT', label: 'Austria' },
  { code: 'BE', label: 'Belgium' },
  { code: 'BR', label: 'Brazil' },
  { code: 'CA', label: 'Canada' },
  { code: 'CN', label: 'China' },
  { code: 'CZ', label: 'Czechia' },
  { code: 'DK', label: 'Denmark' },
  { code: 'FI', label: 'Finland' },
  { code: 'FR', label: 'France' },
  { code: 'DE', label: 'Germany' },
  { code: 'GR', label: 'Greece' },
  { code: 'HK', label: 'Hong Kong' },
  { code: 'HU', label: 'Hungary' },
  { code: 'IN', label: 'India' },
  { code: 'IE', label: 'Ireland' },
  { code: 'IT', label: 'Italy' },
  { code: 'JP', label: 'Japan' },
  { code: 'MY', label: 'Malaysia' },
  { code: 'MX', label: 'Mexico' },
  { code: 'NL', label: 'Netherlands' },
  { code: 'NZ', label: 'New Zealand' },
  { code: 'NO', label: 'Norway' },
  { code: 'PH', label: 'Philippines' },
  { code: 'PL', label: 'Poland' },
  { code: 'PT', label: 'Portugal' },
  { code: 'SG', label: 'Singapore' },
  { code: 'ZA', label: 'South Africa' },
  { code: 'KR', label: 'South Korea' },
  { code: 'ES', label: 'Spain' },
  { code: 'SE', label: 'Sweden' },
  { code: 'CH', label: 'Switzerland' },
  { code: 'TH', label: 'Thailand' },
  { code: 'TR', label: 'Turkey' },
  { code: 'AE', label: 'United Arab Emirates' },
  { code: 'GB', label: 'United Kingdom' },
  { code: 'US', label: 'United States' },
  { code: 'VN', label: 'Vietnam' },
];

export function countryLabelForCode(code, list = PLAYER_COUNTRIES) {
  const c = String(code || '').trim().toUpperCase();
  const hit = (Array.isArray(list) ? list : PLAYER_COUNTRIES).find((row) => row.code === c);
  return hit?.label || c || '—';
}

export function filterCountries(query, list = PLAYER_COUNTRIES) {
  const q = String(query || '').trim().toLowerCase();
  const rows = Array.isArray(list) ? list : PLAYER_COUNTRIES;
  if (!q) return rows;
  return rows.filter((row) => {
    const label = String(row.label || '').toLowerCase();
    const code = String(row.code || '').toLowerCase();
    return label.includes(q) || code.includes(q);
  });
}
